import React, { useState } from "react";
import clsx from "clsx";
import AppBar from "@material-ui/core/AppBar";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Toolbar from "./components/Toolbar";
import DrawerItems from "./components/Drawer";
import useStyles from "./styles";

interface IHeaderProps {}


const Header = (props: IHeaderProps) => {
	const classes = useStyles();
	const [isMobileDrawerOpen, setMobileDrawer] = useState(false);

	return (
		<>
			<AppBar position="fixed" elevation={0} className={classes.appBar}>
				<Toolbar
					onMobileDrawerOpen={setMobileDrawer}
					isMobileDrawerOpen={isMobileDrawerOpen}
				/>
			</AppBar>
			<Hidden smDown implementation="css">
				<Drawer variant="permanent" className={classes.drawer} open={true}>
					<DrawerItems />
				</Drawer>
			</Hidden>
			<Hidden mdUp implementation="css">
				<SwipeableDrawer
					variant="temporary"
					open={isMobileDrawerOpen}
					onOpen={e => setMobileDrawer(true)}
					onClose={e => setMobileDrawer(false)}
					classes={{
						paper: clsx({
							[classes.drawerOpen]: isMobileDrawerOpen,
							[classes.drawerClose]: !isMobileDrawerOpen
						})
					}}
					ModalProps={{
						keepMounted: true
					}}
				>
					<Typography variant="h4" className={classes.siteName}>
						REG Utánfutó
					</Typography>
					<DrawerItems />
				</SwipeableDrawer>
			</Hidden>
		</>
	);
};

export default Header;
